import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  background?: 'default' | 'muted' | 'dark';
  padding?: 'default' | 'large' | 'none';
}
export function Section({
  children,
  className = '',
  background = 'default',
  padding = 'default'
}: SectionProps) {
  const bgClasses = {
    default: 'bg-background',
    muted: 'bg-muted',
    dark: 'bg-foreground text-primary-foreground'
  };
  const paddingClasses = {
    default: 'py-16 md:py-24 px-6',
    large: 'py-24 md:py-32 px-6',
    none: ''
  };
  return <section className={`w-full ${bgClasses[background]} ${paddingClasses[padding]} ${className}`} data-id="element-37">
      {children}
    </section>;
}